module.exports = __webpack_public_path__ + "static/img/6-1.4608f86.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/eng/6-1.png
// module id = Nzq0
// module chunks = 0